<template>
  <div>
    <Header></Header>
    <div class="main2">
      <section class="search-condition">
        <div class="container-xl">
          <ul class="tabs-group">
            <li
              :class="{ active: item.id == activeTabKey }"
              v-for="item in tabList"
              :key="item.id"
              @click="tabChange(item.id)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </section>
<!--      <div class="container-xl xl-main">-->
<!--&lt;!&ndash;<img src="https://kaoguo-api.bankaoedu.com/storage/images/VFsfyJI3oHmiSPzGfp6xnkH5HyZcUUIOw3nMIu4E.png" alt="" style=" width: 1192px;height: 400px;margin-bottom:10px">&ndash;&gt;-->


<!--         &lt;!&ndash; <swiper :options="swiperOptions">-->

<!--      <swiper-slide v-for="(item, index) in slides" :key="index">-->
<!--        <img :src="item.image" alt="Slide">-->
<!--      </swiper-slide>-->

<!--      <div class="swiper-pagination" slot="pagination"></div>-->
<!--    </swiper> &ndash;&gt;-->
<!--      </div>-->
      <!-- kecheng -->
      <section>
        <div class="container-xl xl-main">
          <!-- 轮播图失效 -->
          <div style="width:1200px;max-height: 400px;text-align: center;overflow: hidden;">
            <!--<img src="https://kaoguo-api.bankaoedu.com/storage/images/VFsfyJI3oHmiSPzGfp6xnkH5HyZcUUIOw3nMIu4E.png" alt="" style=" width: 1192px;height: 400px;margin-bottom:10px">-->
            <div v-for="(item, index) in slides" :key="index" style="">
              <img :src="item.image" alt="Slide" style="width: 100%">
            </div>
          </div>
          <CourseItem :pageDataList="dataList"></CourseItem>
        </div>

        <div
          class="container-xl"
          v-if="filter.total"
          :style="{ textAlign: 'center', marginBottom: '20px' }"
        >
          <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :current-page="filter.pageNum"
            :page-size="filter.pageSize"
            :total="filter.total"
          >
          </el-pagination>
        </div>
      </section>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/common/Header";
import Footer from "@/common/Footer";
import CourseItem from "@/components/home/courseItem.vue";

import { getCategory, getCategoryList,getSliders } from "@/service/course";

 
// 如果使用局部注册，需要引入组件
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  data() {
    return {
      tabList: [],
      dataList: [], // 存储从后端获取的数据
      slides:[],
      activeTabKey: "",
      filter: {
        pageSize: 9,
        pageNum: 1,
        total: 0,
      },
      // Swiper 配置选项
      swiperOptions: {
        // 分页器配置
        pagination: {
          el: '.swiper-pagination',
        },
        // 自动播放配置
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        // 循环播放
        loop: true
      }
    };
  },
  components: {
    Header,
    Footer,
    CourseItem,

  swiper,
    swiperSlide

  },
  computed: {
    regAre() {
      let { pageSize, pageNum } = this.filter;

      return {
        id: this.activeTabKey,
        per_page: pageSize,
        page: pageNum,
      };
    },
  },
  async created() {
    await this.getCategoryFn();
    await this.getCategoryListFn();
    await this.getSlidersFn();
  },
  methods: {
   async getSlidersFn(){
      let res = await getSliders()
      if(res.code == 0){
        this.slides = res.data
      }
    },
    tabChange(e) {
      this.activeTabKey = e;
      this.filter.pageNum = 1;
      this.getCategoryListFn();
    },
    // 项目分类
    async getCategoryFn() {
      let res = await getCategory();
      if (res.code == 0) {
        this.tabList = res.data;
        this.activeTabKey = res.data[0] && res.data[0].id;
      }
    },
    async getCategoryListFn() {
      let res = await getCategoryList({
        ...this.regAre,
      });
      this.dataList = res.data.data;
      this.filter.total = res.data.total;
      // console.log(res, "res");
    },
    currentChange(e) {
      this.filter.pageNum = e;
      this.getCategoryListFn();
    },
  },
};
</script>

<style lang="less" scoped>

// .swiper-container {
//   width: 100%;
//   height: 400px;
// }

// .swiper-slide img {
//   width: 100%;
//   height: 100%;
//   object-fit: cover;
// }



.search-condition {
  background: #f3f5f9;
  padding: 30px 0;
}
.classify {
  background: #f3f5f9;
  border-radius: 8px;
  padding: 10px;
}
.cation-middle {
  line-height: 48px;
  font-size: 14px;
}
.cation-list {
  overflow: hidden;
}
.cation-list dt {
  float: left;
  width: 90px;
  font-weight: 700;
  line-height: 48px;
  position: relative;
  color: #333;
}
.cation-list dd {
  border-bottom: 1px dotted #e0e0e0;
  margin-left: 64px;
  overflow: hidden;
  a {
    color: #515759;
    font-size: 14px;
    line-height: 25px;
    height: 25px;
    float: left;
    padding: 0 10px;
    margin: 10px 5px;
  }
}
.cation-list:last-of-type dd {
  border-bottom: 0 none;
}
.cation-list dd a.on,
.cation-list a:hover {
  color: #388fff;
  text-decoration: none;
  background: rgba(44, 128, 255, 0.1);
  border-radius: 5px;
}
.cation-list dt:after {
  content: "";
  position: absolute;
  right: 12px;
  top: 22px;
  border: 1px solid #333;
  border-width: 0 1px 1px 0;
  width: 4px;
  height: 4px;
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
// 课程
.xl-main {
  margin-top: 20px;
  min-height: 400px;
}
.course-content {
  width: 100%;
  min-height: 275px;
  margin-top: 20px;
  display: flex;
}
.content-ul {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
}
.content-li {
  position: relative;
  width: 270px;
  height: 275px;
  margin-right: 20px;
  /* background: palevioletred; */
  margin-bottom: 20px;
  box-shadow: 1px 1px 10px rgb(27 39 94 / 40%);
  border-radius: 8px;
  transition: margin-top 0.2s;
  -webkit-transition: margin-top 0.2s;
  overflow: hidden;
}
.content-li .li-img {
  width: 100%;
  height: 165px;
}
.content-li:nth-child(4n) {
  margin-right: 0;
}

//
.tabs-group {
  display: flex;
  li {
    font-weight: 400;
    font-size: 18px;
    color: #333333;
    line-height: 40px;
    margin-right: 45px;
    cursor: pointer;
  }
  li.active {
    background: #0fce96;
    color: #fff;
    padding: 0 15px;
    border-radius: 4px;
  }
}
</style>